import React,{useRef} from "react"
import {Row, Col} from "react-bootstrap"
import { useNavigate } from 'react-router-dom'
import { useSelector} from "react-redux"
import {useQuery} from "@apollo/client"
import { GET_Liczba_Pytan } from '../Graphql/query'
import ListaRegulamin from "../Regulamin/lista_regulamin"

import KonkursInfo from "../Konkursy/konkurs_informacja"
import Uczestnik from "./uczestnik"

const Regulamin = (props) => {
    const nawigacja = useNavigate()
    const id        = useSelector((magazyn) => magazyn.opcje)
    const uczestnik = useSelector((magazyn) => magazyn.uczestnik ) 
    const zmienneQuery = useRef({
        variables : {id_konkursu : Number(id.id_konkursu),id_uczestnika: Number(uczestnik.id)},
        fetchPolicy:'network-only'
    })
    const powrot = (event) => {
        sessionStorage.clear()
        let url = '/'
        nawigacja(url)
   }

   const start = (event) => {
    let url = `/start`
    nawigacja(url)
}
    const {data,loading,error} = useQuery(GET_Liczba_Pytan,zmienneQuery.current)
    if (loading) { return <p>Wczytywanie danych</p>}
    if (error) {  return <p>Błąd połacznia z bazą danych</p>}
    if (data.liczba_pytan.liczba_pytan <= 0) {nawigacja('/koniec')}
    return (
        <Row className="opispytanie">
            <Uczestnik/>
            <KonkursInfo />
            <ListaRegulamin/>
            <Col xs={6}>
            <button className="btn btn-primary btn-lg btn-block mt-2 przycisk"
                        onClick={powrot}>Rezygnacja</button>
            </Col>
            <Col xs={6}>
            <button className="btn btn-primary btn-lg btn-block mt-2 przycisk"
                        onClick={start}> Akceptuje</button>
            </Col>
        </Row>
        )
}

export default Regulamin